import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AuthService } from '../../Auth/auth.service';
import { FormsModule } from '@angular/forms';
import { Token } from '@angular/compiler';
import { isPlatformBrowser, NgIf } from '@angular/common';
import { DataService } from '../../Services/Data Service/data.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterLink, FormsModule, NgIf],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {

  loginhead = 'Sign In';

  loading: boolean = false;

  readonly backgrounds = [
    'assets/unipet-bg2.jpg',
    'assets/unipet-bg3.jpg'
  ];
  randomNumber = Math.floor(Math.random() * this.backgrounds.length);

  bgImage = this.backgrounds[this.randomNumber];

  username: string = '';
  password: string = '';
  hidePassword = true;
  error_message: string = "";

  user: any;
  submissionComplete = false;


  constructor(
    private authService: AuthService, 
    private router: Router, 
    private route: ActivatedRoute,
    private dataService: DataService,
    private msalService: MsalService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    //logout so after submission when this page is loaded you have to login again
    // if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    //   this.authService.logout();
    // }

    if (isPlatformBrowser(this.platformId)) {
    const submissionComplete = localStorage.getItem('submissionComplete');
    if (submissionComplete === 'true') {
      this.submissionComplete = true; // Use this to show a toast/modal
      localStorage.removeItem('submissionComplete'); // Clean up
    }
  };

    const reason = this.route.snapshot.queryParamMap.get('reason');
    if (reason === 'session-expired') {
      this.error_message = 'Session expired. Refresh to continue.';
    }
  }
  

  onSubmit() {
    // if (this.username?.endsWith('@unipet.co')) {
    //   if (confirm('Please use Microsoft login for @unipet.co emails. Continue?')) {
    //     this.Mslogin(); // or open a Microsoft auth URL
    //   }
    //   return;
    // }
  
    // Otherwise, proceed with normal login
    this.login();
  }

  
  // Custom login method
  login(): void {
    this.loading = true;

    this.authService.login(this.username, this.password).subscribe(
      (response) => {
        console.log('Raw login response:', response);

        if (response && response.accessToken && response.refreshToken) {
          console.log('JWT token received:', response.accessToken);
          console.log('Refresh token received:', response.refreshToken);

          // Store credentials
          this.authService.storeCredentials(this.username, response.accessToken, response.refreshToken);
          this.authService.setAccessToken(response.accessToken);

          // Intentional refresh: populate shared currentUser$ after login (forceRefresh = true).
          this.dataService.getCurrentUser(true).subscribe({
            next: (user) => {
              this.loading = false;

              if (!user) {
                console.error('User not found after login');
                this.error_message = 'User not found after login';
                return;
              }

              console.log('User found after login:', user);

              // Navigate based on role
              switch (user.role) {
                case 'Admin':
                case 'SuperAdmin':
                  this.router.navigate(['/dashboard']);
                  break;
                case 'Vendor':
                  this.router.navigate(['/registrationform']);
                  break;
                case 'Guest':
                  this.router.navigate(['/start']);
                  break;
                default:
                  console.warn('Unknown role:', user.role);
                  this.router.navigate(['/unauthorized']);
                  break;
              }
            },
            error: (err) => {
              this.loading = false;
              console.error('Error fetching current user after login:', err);
              this.error_message = 'Failed to fetch user after login. Please try again.';
            }
          });

        } else {
          this.loading = false;
          console.warn('Unexpected response structure:', response);
          this.error_message = 'Unexpected response from server.';
        }
      },
      (error) => {
        this.loading = false;
        if (error.status === 400 || error.status === 401) {
          this.error_message = 'Invalid username or password.';
        } else if (error.status === 500) {
          this.error_message = 'Something went wrong on the server. Please try again.';
        } else {
          this.error_message = 'Unexpected error. Please try again later.';
        }
      }
    );
  }



  Mslogin(){
    this.authService.loginEntra()
    this.msalService.initialize().subscribe({
      next: () => {
        console.log('MSAL Initialized for loginRedirect!');
        this.msalService.loginPopup(  {
          prompt: 'login',
          scopes: []
        })
      },
      error: (error: any) => {
        console.error('Error initializing MSAL:', error);
            }
    })}};  
  